module.exports = __webpack_public_path__ + "static/img/sbgl.34a521cb.png";